import { Component, DoCheck, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { Observable, Subject, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {
  AbstractControl,
  AbstractDynamicForm,
  AbstractValueControlBase,
  bindCascade,
  bindUnionCheck,
  camelCaseObject,
  ChildFormDataModel,
  ControlBroadCastEvent,
  ControlDataModel,
  ControlSharedService,
  controlsTraversalPipe,
  controlsTraversalPipeReturn,
  ControlTranslate,
  ControlTranslateService,
  ControlValidatorService,
  ControlViewModel,
  DynamicControlContainer,
  DynamicFormDataModel,
  DynamicFormDataModelData,
  DynamicFormEvent,
  DynamicFormEventType,
  DynamicFormModel,
  DynamicFormRunHelperService,
  DynamicFormUpdateDataModel,
  executeFormEvent,
  isFunction,
  mergeDiffContent,
  setControlValidator,
  toDynamicFormModel,
  ControlOperateMode
} from 'zr-dynamic-form/dynamic-form-designer';

import { FormDataService } from './services/form-data.service';
import { LayoutHostRuntimeDirective } from './utils/layout-host-runtime.directive';
import { removeUnnecessaryProperty, removeUnnecessaryChildFormData } from './utils/form-data-helper';

// è¿éçå¼å¥è·¯å¾å¯è½é ææåå¤±è´¥ï¼æ³¨æè·¯å¾çå¼å¥ï¼å°¤å¶æ¯designerä¸­çï¼è¯·ä½¿ç¨zr-dynamic-form/dynamic-form-designerè¿ä¸ªè·¯å¾ï¼ä¸è¦ç¨ä¸çº§è·¯å¾
@Component({
  selector: 'lib-dynamic-form-runtime,df-dynamic-form-runtime,zr-dynamic-form-runtime',
  templateUrl: './dynamic-form-runtime.component.html',
  styleUrls: ['./dynamic-form-runtime.component.scss'],
  exportAs: 'DynamicFormRuntimeComponent',
  providers: [ControlTranslateService, ControlSharedService]
})
export class DynamicFormRuntimeComponent extends AbstractDynamicForm
  implements DynamicControlContainer, DoCheck, OnInit, OnDestroy {
  @Input()
  set formCode(formCode: string) {
    this._formCode = formCode;
    this._dataModel.formCode = formCode;
    // this.loadFormContent();
  }
  get formCode(): string {
    return this._formCode;
  }
  @Input()
  set labelCode(labelCode: string) {
    this._labelCode = labelCode;
  }
  get labelCode(): string {
    return this._labelCode;
  }

  @Input()
  set dataModel(context: DynamicFormDataModel) {
    this._dataModel = context;
  }
  get dataModel(): DynamicFormDataModel {
    return this._dataModel;
  }

  @Input()
  set readOnly(readOnly: boolean) {
    this._readOnly = readOnly;
    this.setReadOnly();
  }

  get readOnly(): boolean {
    return this._readOnly;
  }

  @Input()
  set enableEditAtView(enableEditAtView: boolean) {
    this._enableEditAtView = enableEditAtView;
  }

  get enableEditAtView(): boolean {
    return this._enableEditAtView;
  }

  @Input()
  set enableEditNameList(enableEditNameList: string[]) {
    this._enableEditNameList = enableEditNameList;
    // this.setReadOnly();
  }
  get enableEditNameList(): string[] {
    return this._enableEditNameList;
  }

  @Input() set targetId(val: string) {
    this._targetId = val;
  }
  get targetId(): string {
    return this._targetId;
  }
  @Input()
  set globalData(data: any) {
    this._globalData = data;
    this.controlSharedService.sendGlobalDataChange(data);
  }
  get globalData(): any {
    return this._globalData;
  }

  /**
   * è¡¨åç¶æ
   */
  get valid(): boolean {
    return this._valid;
  }

  @Output() beforeLoad: EventEmitter<any> = new EventEmitter();
  @Output() afterLoad: EventEmitter<any> = new EventEmitter();
  @Output() beforeDataLoad: EventEmitter<any> = new EventEmitter();
  @Output() afterDataLoad: EventEmitter<any> = new EventEmitter();
  @Output() controlBroadCast: EventEmitter<ControlBroadCastEvent> = new EventEmitter<ControlBroadCastEvent>();

  loadErrorMsg: string;
  controlTranslate: ControlTranslate;
  controls: AbstractControl<ControlViewModel>[] = [];

  private _globalData: any;
  private _formCode: string;
  private _labelCode: string;
  private _dataModel: DynamicFormDataModel = { targetId: '0', formCode: '', data: undefined };
  private _readOnly: boolean;
  private _enableEditAtView: boolean;
  private _targetId: string;
  private _enableEditNameList: string[] = [];
  private formEventModels = Array<DynamicFormEvent>();
  private formLoading: boolean = false; // è¡¨åå è½½ä¸­
  private formDataLoading = false; // è¡¨åæ°æ®å è½½ä¸­
  private _loadComponentSubscription: Subscription;
  private _controlResolvedSubscription: Subscription;
  private _controlBroadCastSubscription: Subscription;

  private _valid: boolean;
  private _originFormValue: DynamicFormDataModelData; // åå§è¡¨åæ°æ®
  private _dynamicFormModel: DynamicFormModel;

  @ViewChild(LayoutHostRuntimeDirective) layoutHost: LayoutHostRuntimeDirective;

  constructor(
    private controlTranslateService: ControlTranslateService,
    private formDataHandlerService: FormDataService,
    private controlValidatorService: ControlValidatorService,
    private controlSharedService: ControlSharedService,
    private runHelperService: DynamicFormRunHelperService
  ) {
    super();
  }

  ngOnInit() {
    this._loadComponentSubscription = this.controlTranslateService.loadComponentModel$.subscribe((s) => {
      this.controlTranslateService.loadComponentsByModel(s);
    });

    this.subscribeControlResolved();

    this._controlBroadCastSubscription = this.controlSharedService.controlBroadCasted$.subscribe((s) => {
      this.controlBroadCast.emit(s);
    });

    this.loadFormContent().subscribe(
      (s) => {
        if (this.targetId) {
          this.detail(this.targetId);
        }
      },
      (error) => {
        this.loadErrorMsg = error;
      }
    );
  }

  ngOnDestroy(): void {
    this._loadComponentSubscription.unsubscribe();
    this._controlResolvedSubscription.unsubscribe();
    this._controlBroadCastSubscription.unsubscribe();
  }

  ngDoCheck(): void {
    this._valid = this.getValid();
  }

  getValid() {
    if (this.formLoading || this.formDataLoading || !this.controls) {
      return false;
    }

    let isValid = true;

    controlsTraversalPipeReturn(this.controls, (c) => {
      if (c.hidden) {
        return null;
      }

      if (!c.valid) {
        isValid = false;
        return isValid;
      }
      return null;
    });
    return isValid;
  }

  /**
   * å è½½è¡¨ååå®¹
   *
   * @memberof DynamicFormRuntimeComponent
   */
  loadFormContent(): Observable<any> {
    const sub$ = new Subject();
    this.formLoading = true;
    this.loadErrorMsg = '';
    this.loadComponents([]);

    this.beforeLoad.emit();
    executeFormEvent(this.formEventModels, DynamicFormEventType.BeforeLoad, this);

    if (!this.formCode) {
      this.loadErrorMsg = `è¡¨åç¼å·ä¸å­å¨`;
      executeFormEvent(this.formEventModels, DynamicFormEventType.AfterLoad, this);
      return new Observable((observer) => {
        observer.error(this.loadErrorMsg);
      });
    }

    this.formDataHandlerService
      .getFormContent(this.formCode, this.labelCode)
      .pipe(
        finalize(() => {
          this.afterLoad.emit();
          executeFormEvent(this.formEventModels, DynamicFormEventType.AfterLoad, this);
        })
      )
      .subscribe(
        (res) => {
          const formModel = toDynamicFormModel(JSON.parse(res.formContent));
          this._dynamicFormModel = mergeDiffContent(formModel, camelCaseObject(JSON.parse(res.labelContent)));

          this.formEventModels = this._dynamicFormModel.form.events;
          this.loadComponents(this._dynamicFormModel.controls);
          this.bindShowHiddenRule(this._dynamicFormModel.form.showHiddenRules);

          sub$.next('complete');
          // æ¾å¨ä¸ä¸å¨ææ§è¡ï¼å¦åä¼åºé
          setTimeout(() => {
            // å»ææ ç¨çé»è®¤å¼èµå¼æä½ï¼è¯¥æä½å·²è¢«å¼ç¨
            // this.updateControlDefaultValue();
            this.formLoading = false;
          }, 0);
        },
        (error) => {
          this.loadErrorMsg = `${error.error}`;
          sub$.error(this.loadErrorMsg);
        }
      );
    return sub$.asObservable();
  }

  /**
   * è·åå½åè¡¨åæ°æ®
   *
   * @param  targetId ç®æ æ°æ®Id
   * @param  [isRemoveUnnecessaryChildFormData=false] æ¯å¦ç§»é¤ä¸å¿è¦çå­è¡¨åæ°æ®
   *
   * æ´æ°æ°æ®æ¶ï¼å¯ä»¥éè¿è®¾ç½®isRemoveUnnecessaryChildFormDataä¸ºtrueæ¥ç§»é¤å­è¡¨åä¸å¿è¦çæ°æ®æ¥æåæ§è½
   *
   */
  getCurrentDataModel(targetId: string, isRemoveUnnecessaryChildFormData: boolean = false): DynamicFormDataModel {
    this._dataModel.targetId = targetId;
    this._dataModel.data = this.runHelperService.getControlsValue(this.controls);

    if (this._originFormValue && isRemoveUnnecessaryChildFormData) {
      removeUnnecessaryChildFormData(this._dataModel.data.childrenFormData, this._originFormValue.childrenFormData);
    }

    removeUnnecessaryProperty(this._dataModel.data.childrenFormData);

    return this._dataModel;
  }

  // æ·»å 
  add(targetId: string): Observable<any> {
    const context = this.getCurrentDataModel(targetId);

    const sub$ = new Subject();
    this.addDynamicFormContext(context)
      .pipe(finalize(() => sub$.complete()))
      .subscribe(
        (s) => {
          this.validateControls();
          sub$.next(`æ·»å æå`);
        },
        (error) => {
          return sub$.error(`${error.error}`);
        }
      );
    return sub$;
  }

  /**
   * æ´æ°
   *
   * @param targetId
   * @param autoAdd æ°æ®ä¸å­å¨æ¶æ¯å¦èªå¨æ·»å  é»è®¤true
   */
  update(targetId: string, autoAdd: boolean = true): Observable<any> {
    if (!this.valid) {
      return new Observable((observer) => {
        observer.error(`è¯·æ­£ç¡®å¡«åè¡¨ååå®¹`);
      });
    }
    const context: DynamicFormUpdateDataModel = this.getCurrentDataModel(targetId, true);
    context.autoAdd = autoAdd;

    const sub$ = new Subject();
    this.updateDynamicFormContext(context)
      .pipe(finalize(() => sub$.complete()))
      .subscribe(
        (s) => {
          this.validateControls();
          sub$.next(`æ´æ°æå`);
        },
        (error) => {
          return sub$.error(`æ´æ°è¡¨åå¤±è´¥, ${error.error}`);
        }
      );
    return sub$;
  }

  // å é¤
  delete(targetId: string): Observable<any> {
    const sub$ = new Subject();
    this.formDataHandlerService
      .delete(this.formCode, targetId)
      .pipe(finalize(() => sub$.complete()))
      .subscribe(
        (s) => {
          this.clear();
          sub$.next(`å é¤æå`);
        },
        (error) => {
          return sub$.error(`å é¤è¡¨åå¤±è´¥, ${error.error}`);
        }
      );
    return sub$;
  }

  // æ¸ç©ºè¡¨å
  clear() {
    super.clear(this.runHelperService);
  }

  // æ·»å è¡¨åæ°æ®
  addDynamicFormContext(dataModel: DynamicFormDataModel): Observable<any> {
    return this.formDataHandlerService.add(dataModel);
  }

  // æ´æ°è¡¨åæ°æ®
  updateDynamicFormContext(dataModel: DynamicFormUpdateDataModel): Observable<any> {
    return this.formDataHandlerService.update(dataModel);
  }

  // ä»è¿ç«¯è·åè¯¦æï¼å¹¶è®¾ç½®æ§ä»¶å¼
  detail(targetId: string): Observable<any> {
    this.formDataLoading = true;

    this.targetId = targetId;
    this.beforeDataLoad.emit(targetId);
    executeFormEvent(this.formEventModels, DynamicFormEventType.BeforeDataLoad, this);
    // this.clear();

    const sub$ = new Subject();
    this.formDataHandlerService
      .detail(this._formCode, targetId)
      .pipe(
        finalize(() => {
          this.afterDataLoad.emit();
          executeFormEvent(this.formEventModels, DynamicFormEventType.AfterDataLoad, this);
          sub$.complete();
        })
      )
      .subscribe(
        (s) => {
          if (s === null) {
            this.formDataLoading = false;
            sub$.error(`å¯¹åºæ°æ®ä¸å­å¨`);
            return;
          }
          this._originFormValue = s.data ? s.data : {};

          this.setControlsValue(this._originFormValue);
          this.bindShowHiddenRule(this._dynamicFormModel.form.showHiddenRules);
          this.triggerDefaultCascade();

          sub$.next();
          this.formDataLoading = false;
        },
        (error) => {
          sub$.error(`è·åè¡¨åè¯¦æå¤±è´¥, ${error.error}`);
        }
      );
    return sub$;
  }

  /**
   * æ ¹æ®åç§°æ´æ°æ§ä»¶å¼
   */
  updateControlValue(name: string, value: any): AbstractControl<ControlViewModel> {
    const control = this.findControlByName(name);
    return this.updateControlValueByControl(control, value);
  }
  /**
   * æ ¹æ®æ§ä»¶æ´æ°æ§ä»¶å¼
   * @param control æ§ä»¶
   * @param value æ§ä»¶å¼
   * @param isBroadCast æ¯å¦å¹¿æ­
   */
  updateControlValueByControl(
    control: AbstractControl<any>,
    value: any,
    isBroadCast: boolean = true
  ): AbstractControl<any> {
    if (!control) {
      return control;
    }

    control.setModelValue(value);
    const valueControl = control as AbstractValueControlBase<any>;

    if (isFunction(valueControl.validate)) {
      valueControl.validate();
    }

    if (isBroadCast && isFunction(valueControl.broadControlValueChange)) {
      valueControl.broadControlValueChange();
    }
    return control;
  }

  /**
   * è®¾ç½®æææ§ä»¶å¼
   */
  setControlsValue(dataValue: any) {
    controlsTraversalPipe(this.controls, (c) => this.runHelperService.setControlValue(c, dataValue, this.targetId));
  }

  /**
   * è®¾ç½®æ§ä»¶readonlyç¶æ
   */
  setReadOnly() {
    controlsTraversalPipe(this.controls, (c) => this.setControlReadOnly(c));
  }

  /**
   * è§¦åé»è®¤çº§è
   */
  triggerDefaultCascade() {
    controlsTraversalPipe(this.controls, (c) => {
      if (c instanceof AbstractValueControlBase && c.onDefaultCascadeValueChange) {
        c.onDefaultCascadeValueChange();
      }
    });
  }

  setControlOperateMode(control: AbstractControl<any>) {
    if (control && control instanceof AbstractValueControlBase) {
      if (this._readOnly) {
        control.operateMode = ControlOperateMode.View;
        return;
      }
      if (this.targetId) {
        control.operateMode = ControlOperateMode.Edit;
        return;
      }
      control.operateMode = ControlOperateMode.Add;
    }
  }

  private loadComponents(dataModels: Array<ControlDataModel>) {
    dataModels = camelCaseObject(dataModels);
    dataModels = this.controlTranslateService.filterNotDisplayControl(dataModels);
    const controls = this.controlTranslateService.loadComponents(dataModels, this, false);
    this.controls = controls;

    controlsTraversalPipe(
      this.controls,
      (c) => {
        bindCascade(c, this.controls), bindUnionCheck(c, this.controls);
      },
      (c) => this.runHelperService.setControlFormCode(c, this.formCode),
      (c) => this.setControlReadOnly(c),
      (c) => this.setControlOperateMode(c)
    );
  }

  private subscribeControlResolved() {
    this._controlResolvedSubscription = this.controlTranslateService.controlResolved.subscribe((s) => {
      s.controlShared = this.controlSharedService;
      s.dataConfig.targetId = this.targetId;
      setControlValidator(s, this.controlValidatorService);
    });
  }

  /**
   * è®¾ç½®æ§ä»¶åªè¯»
   */
  private setControlReadOnly(control: AbstractControl<any>) {
    if (control) {
      control.viewOnly = this._readOnly;
      control.enableEditAtView = this._enableEditAtView;
      control.enableEditNameList = this._enableEditNameList;
    }
  }

  // æææ§ä»¶å¼å§éªè¯å¨éªè¯
  private validateControls() {
    controlsTraversalPipe(this.controls, (c) => {
      if (!c.hidden) {
        this.runHelperService.validateControl(c);
      }
    });
  }
}
